import * as React from "react"
import Svg, { Path } from "react-native-svg"


export const LeafIcon = (props) => (
    <Svg
        width="700px"
        height="700px"
        viewBox="0 0 700 700"
        {...props}
    >
        <Path d="M400.82 59.902c-143.36-15.414-222.92 59.727-249.45 91.031-18.828 19.43-33.605 43.305-42.543 70.82-12.562 38.914-11.324 78.98.973 114.85 69.105-90.055 184.84-106.89 217.03-109.89-37.57 19.004-202.82 111.59-239.82 286.38-.391 1.434-.887 2.832-1.223 4.281-.902 3.63-1.75 7.254-2.512 11.008-.441 2.125-.922 4.23-1.113 6.406-.867 4.106-2.14 14.688 4.832 17.45l23.625 7.363s12.477 3.468 12.211-10.531c.266-46.72 12.512-99.062 43.676-130.62 17.164 14.14 37.234 25.359 59.707 32.613 56.93 18.367 116.34 7.254 161.66-24.988C548.733 326.16 618.493.005 618.493.005 558.555 78.95 400.833 59.91 400.833 59.91zm-66.008 166.5-.02-.281c.372 0 .637-.07.637-.07-.191.14-.422.261-.617.351z" />
    </Svg>
)
